export default "__VITE_ASSET__de1a336d__"